/**
 * マスターのバリューの列挙クラス
 */

/**
 * 都道府県の列挙クラス
 * @param code : 都道府県コード
 * @param name : 都道府県名(漢字)
 * @param name_r : 都道府県名(ローマ字)
 */
const _prefs = [
  { "code": '01', "name": '北海道', "name_r": 'hokkaido' },
  { "code": '02', "name": '青森県', "name_r": 'aomori' },
  { "code": '03', "name": '岩手県', "name_r": 'iwate' },
  { "code": '04', "name": '宮城県', "name_r": 'miyagi' },
  { "code": '05', "name": '秋田県', "name_r": 'akita' },
  { "code": '06', "name": '山形県', "name_r": 'yamagata' },
  { "code": '07', "name": '福島県', "name_r": 'fukushima' },
  { "code": '08', "name": '茨城県', "name_r": 'ibaraki' },
  { "code": '09', "name": '栃木県', "name_r": 'tochigi' },
  { "code": '10', "name": '群馬県', "name_r": 'gunma' },
  { "code": '11', "name": '埼玉県', "name_r": 'saitama' },
  { "code": '12', "name": '千葉県', "name_r": 'chiba' },
  { "code": '13', "name": '東京都', "name_r": 'tokyo' },
  { "code": '14', "name": '神奈川県', "name_r": 'kanagawa' },
  { "code": '15', "name": '新潟県', "name_r": 'niigata' },
  { "code": '16', "name": '富山県', "name_r": 'toyama' },
  { "code": '17', "name": '石川県', "name_r": 'ishikawa' },
  { "code": '18', "name": '福井県', "name_r": 'fukui' },
  { "code": '19', "name": '山梨県', "name_r": 'yamanashi' },
  { "code": '20', "name": '長野県', "name_r": 'nagano' },
  { "code": '21', "name": '岐阜県', "name_r": 'gifu' },
  { "code": '22', "name": '静岡県', "name_r": 'shizuoka' },
  { "code": '23', "name": '愛知県', "name_r": 'aichi' },
  { "code": '24', "name": '三重県', "name_r": 'mie' },
  { "code": '25', "name": '滋賀県', "name_r": 'shiga' },
  { "code": '26', "name": '京都府', "name_r": 'kyoto' },
  { "code": '27', "name": '大阪府', "name_r": 'osaka' },
  { "code": '28', "name": '兵庫県', "name_r": 'hyogo' },
  { "code": '29', "name": '奈良県', "name_r": 'nara' },
  { "code": '30', "name": '和歌山県', "name_r": 'wakayama' },
  { "code": '31', "name": '鳥取県', "name_r": 'tottori' },
  { "code": '32', "name": '島根県', "name_r": 'shimane' },
  { "code": '33', "name": '岡山県', "name_r": 'okayama' },
  { "code": '34', "name": '広島県', "name_r": 'hiroshima' },
  { "code": '35', "name": '山口県', "name_r": 'yamaguchi' },
  { "code": '36', "name": '徳島県', "name_r": 'tokushima' },
  { "code": '37', "name": '香川県', "name_r": 'kagawa' },
  { "code": '38', "name": '愛媛県', "name_r": 'ehime' },
  { "code": '39', "name": '高知県', "name_r": 'kochi' },
  { "code": '40', "name": '福岡県', "name_r": 'fukuoka' },
  { "code": '41', "name": '佐賀県', "name_r": 'saga' },
  { "code": '42', "name": '長崎県', "name_r": 'nagasaki' },
  { "code": '43', "name": '熊本県', "name_r": 'kumamoto' },
  { "code": '44', "name": '大分県', "name_r": 'oita' },
  { "code": '45', "name": '宮崎県', "name_r": 'miyazaki' },
  { "code": '46', "name": '鹿児島県', "name_r": 'kagoshima' },
  { "code": '47', "name": '沖縄県', "name_r": 'okinawa' },
]
const _userstatus = [
  { "code": 0, "value": "退会" },
  { "code": 1, "value": "アクティブ" },
]
/**
 * 日本語レベルの列挙クラス
 * @param code : コード
 * @param level : 日本語レベル
 */
const _langLevels = [
  { "code": 1, "level": 'N1' },
  { "code": 2, "level": 'N2' },
  { "code": 3, "level": 'N3' },
  { "code": 4, "level": 'N4' },
  { "code": 5, "level": 'N5' },
  { "code": 9, "level": '不問(NONE)' },
]

/**
 * 出力情報列挙クラス
 * @param name : 出力情報
 * @param label : ラベル
 */
const _outputInfo = [
  { "name": "user", "label": '顧客情報' },
  { "name": "jobs", "label": '仕事情報' },
  { "name": "job_apply", "label": '仕事応募履歴' },
  { "name": "job_detail_view_histories", "label": '仕事閲覧履歴' },
  { "name": "service_link_click_histories", "label": 'サービスリンク履歴' },
]

/**
 * 仕事系専用のマスターバリュー
 */
const _jobValues = {
  /**
  * 表示ステータス
  * @param code コード
  * @param label ラベル
  */
  dispStatus: [
    { "code": 0, "label": '非表示' },
    { "code": 1, "label": '表示' },
  ],
  /**
  * 必須チェック
  * @param key 必須対象
  * @param label ラベル
  */
  required: [
    { "key": "dispStatus", "label": "表示ステータス" },
    { "key": "summary", "label": "仕事概要" },
    { "key": "applyUrl", "label": "申し込みURL" },
    { "key": "prefCode", "label": "勤務地" },
    { "key": "salaryF", "label": "給与_FROM" },
    { "key": "japlevel", "label": "日本語レベルコード" },
    { "key": "hour1F", "label": "勤務時間1_FROM" },
    { "key": "hour1T", "label": "勤務時間1_TO" },
    { "key": "empType", "label": "雇用形態" },
  ]
}
const _redirects = [
  { "name": "地球人", "value": "c" },
  { "name": "VIVA", "value": "v" },
  { "name": "KIBI", "value": "k" },
  { "name": "Smiles", "value": "dw" }
];

const _identification_codes = {
  "1": "代表契約",
  "2": "一般契約"
};

const _account_type_codes = {
  "1": "普通預金",
  "2": "当座預金"
};

const _authentication_a_codes = {
  "01": "運転免許証",
  "02": "パスポート",
  "03": "健康保険証＋住民票写し(原本)",
  "04": "住基カード＋住民票写し(原本)",
  "05": "外国人登録証明書",
  "06": "新生銀行確認１",
  "07": "新生銀行確認２",
  "08": "特別永住者証明書",
  "09": "在留カード",
  "10": "健康保険証",
  "11": "住民票写し(原本)",
  "12": "運転経歴証明書",
  "13": "年金手帳",
  "14": "住基カード",
  "15": "各種社会厚生福祉手帳",
  "16": "受任通知/破産開始通知",
  "17": "その他",
  "18": "個人番号カード",
  "19": "運転免許証＋健康保険証",
  "20": "運転免許証＋パスポート",
  "21": "運転免許証＋個人番号カード",
  "22": "運転免許証＋在留カード",
  "23": "運転免許証＋年金手帳",
  "24": "運転免許証＋特別永住者証明書",
  "25": "運転免許証＋小型船舶操縦免許証",
  "26": "運転免許証＋その他",
  "27": "健康保険証＋パスポ－ト",
  "28": "健康保険証＋個人番号カ－ド",
  "29": "健康保険証＋在留カ－ド",
  "30": "健康保険証＋年金手帳",
  "31": "健康保険証＋特別永住者証明書",
  "32": "健康保険証＋小型船舶操縦免許証",
  "33": "健康保険証＋運転経歴証明書",
  "34": "健康保険証＋その他",
  "35": "パスポート＋個人番号カ－ド",
  "36": "パスポート＋年金手帳",
  "37": "パスポート＋特別永住者証明書",
  "38": "パスポート＋運転経歴証明書",
  "39": "パスポート＋小型船舶操縦免許証",
  "40": "パスポート＋その他",
  "41": "個人番号カード＋在留カード",
  "42": "個人番号カード＋年金手帳",
  "43": "個人番号カード＋特別永住者証明書",
  "44": "個人番号カード＋運転経歴証明書",
  "45": "個人番号カード＋小型船舶操縦免許証",
  "46": "個人番号カード＋その他",
  "47": "在留カード＋年金手帳",
  "48": "在留カード＋運転経歴証明書",
  "49": "在留カード＋小型船舶操縦免許証",
  "50": "在留カード＋その他",
  "51": "年金手帳＋特別永住者証明書",
  "52": "年金手帳＋小型船舶操縦免許証",
  "53": "年金手帳＋その他",
  "54": "運転経歴証明書＋年金手帳",
  "55": "運転経歴証明書＋特別永住者証明書",
  "56": "運転経歴証明書＋小型船舶操縦免許証",
  "57": "運転経歴証明書＋その他",
  "58": "特別永住者証明書＋小型船舶操縦免許証",
  "59": "特別永住者証明書＋その他",
  "60": "その他＋その他",
  "61": "小型船舶操縦免許証",
  "62": "印鑑証明書(原本）"
};

const _authentication_b_codes = {
  "01": "電気料金明細書(原本)",
  "02": "電話料金明細書(原本)",
  "03": "水道料金明細書(原本)",
  "04": "外国人登録原票記載事項証明書(原本)",
  "05": "その他",
  "06": "電気料金明細書＋電話料金明細書",
  "07": "電気料金明細書＋水道料金明細書",
  "08": "電気料金明細書＋その他",
  "09": "電話料金明細書＋水道料金明細書",
  "10": "電話料金明細書＋その他",
  "11": "水道料金明細書＋その他",
  "12": "その他＋その他"
};

const _transaction_purpose_code = {
  "01": "留学",
  "02": "ビジネス",
  "03": "文化活動",
  "04": "観光",
  "05": "ショッピング",
  "06": "親族・知人訪問",
  "07": "その他"
};

const _occupation_code = {
  "01": "正社員",
  "02": "契約社員",
  "03": "一般派遣社員",
  "04": "パート社員",
  "05": "アルバイト",
  "06": "自営業",
  "07": "自由業",
  "08": "公務員",
  "09": "会社役員",
  "10": "その他"
};

const _card_types_code = {
  "00001": "BANKIT Me（メイン）",
  "00002": "BANKIT You（メイン）",
  "00003": "BANKIT You（リアルカード）",
  "00004": "BANKIT Me（サブ）",
  "00005": "BANKIT You（サブ）"
};

const _csvFields = {
  date_created: { title: '実績年月' },
  contract_number: { title: '契約番号' },
  customer_number: { title: '顧客番号' },
  entry_number: { title: '申込番号' },
  identification: { title: '名寄せ識別' },
  representative_contract_number: { title: '代表契約番号' },
  popinfoId: { title: 'popinfoID' },
  branch_number: { title: '支店ｺｰﾄﾞ' },
  account_type: { title: '預金種別' },
  account_number: { title: '口座番号' },
  account_number_branch: { title: '口座番号枝番' },
  authentication_a: { title: '本人確認資料A種別' },
  a_date_confirmation: { title: '本人確認資料A確認日' },
  authentication_b: { title: '本人確認資料B種別' },
  b_date_confirmation: { title: '本人確認資料B確認日' },
  brand_id: { title: 'ブランドﾞID' },
  grade_id: { title: 'グレードID' },
  card_type: { title: 'カード種類' },
  usage_limit_1_time: { title: '利用限度額(国内ショッピング/1回)' },
  usage_limit_day: { title: '利用限度額(国内ショッピング/1日)' },
  usage_limit_month: { title: '利用限度額(国内ショッピング/1ヶ月)' },
  usage_limit_1_time_overseas: { title: '利用限度額(海外ショッピング/1回)' },
  usage_limit_day_overseas: { title: '利用限度額(海外ショッピング/1日)' },
  usage_limit_month_overseas: { title: '利用限度額(海外ショッピング/1ヶ月)' },
  withdraw_limit_1_overseas: { title: '利用限度額(海外現金引出/1回)' },
  withdraw_limit_day_overseas: { title: '利用限度額(海外現金引出/1日)' },
  withdraw_limit_month_overseas: { title: '利用限度額(海外現金引出/1ヶ月)' },
  contract_date: { title: '契約日' },
  cancellation_date: { title: '解約日' },
  valid_member_flag: { title: '有効会員フラグ(AGRDTE,KYKDTE)' },
  contract_update_day: { title: '変更日（契約データ）' },
  transaction_purpose: { title: '取引目的' },
  transaction_purpose_other: { title: '取引目的（その他）' },
  occupation: { title: '職業' },
  occupation_other: { title: '職業（その他）' },
  data_entry_date: { title: 'データ基準日' },
  postal_code: { title: '郵便番号' },
  address1: { title: '漢字住所1' },
  address2: { title: '漢字住所2' },
  telephone: { title: '電話番号' },
  mobile: { title: '携帯電話番号' },
  customer_update_day: { title: '変更日（顧客データ）' },
  kana_name: { title: 'ｶﾅ英字氏名' },
  kanji_name: { title: '漢字氏名' },
  emboss: { title: 'エンボスローマ字' },
  gender: { title: '性別区分' },
  birthday: { title: '生年月日' },
  card_expiration: { title: 'カード有効期限' },
  last_good_through: { title: 'カード前有効期限' },
  data_created_at: { title: 'データ作成日' },
  application_date: { title: '申込日' },
  card_issuance_instruction_date: { title: 'カード発行指示日' },
  card_shipping_date: { title: 'ｶｰﾄﾞ送付日' },
  link_origin: { title: '遷移元提携先情報' },
  rankup_date: { title: 'ランクアップ日' },
  card_issuance_date: { title: 'カード作成依頼日' },
  account_balance: { title: 'プリペイド口座残高' },
}

const _csvFieldsChoysan = {
  date_created: { title: '実績年月' },
  contract_number: { title: '契約番号' },
  customer_number: { title: '顧客番号' },
  entry_number: { title: '申込番号' },
  identification: { title: '名寄せ識別' },
  representative_contract_number: { title: '代表契約番号' },
  popinfoId: { title: 'popinfoID' },
  branch_number: { title: '支店ｺｰﾄﾞ' },
  account_type: { title: '預金種別' },
  account_number: { title: '口座番号' },
  account_number_branch: { title: '口座番号枝番' },
  authentication_a: { title: '本人確認資料A種別' },
  a_date_confirmation: { title: '本人確認資料A確認日' },
  authentication_b: { title: '本人確認資料B種別' },
  b_date_confirmation: { title: '本人確認資料B確認日' },
  brand_id: { title: 'ブランドﾞID' },
  grade_id: { title: 'グレードID' },
  card_type: { title: 'カード種類' },
  usage_limit_1_time: { title: '利用限度額(国内ショッピング/1回)' },
  usage_limit_day: { title: '利用限度額(国内ショッピング/1日)' },
  usage_limit_month: { title: '利用限度額(国内ショッピング/1ヶ月)' },
  usage_limit_1_time_overseas: { title: '利用限度額(海外ショッピング/1回)' },
  usage_limit_day_overseas: { title: '利用限度額(海外ショッピング/1日)' },
  usage_limit_month_overseas: { title: '利用限度額(海外ショッピング/1ヶ月)' },
  withdraw_limit_1_overseas: { title: '利用限度額(海外現金引出/1回)' },
  withdraw_limit_day_overseas: { title: '利用限度額(海外現金引出/1日)' },
  withdraw_limit_month_overseas: { title: '利用限度額(海外現金引出/1ヶ月)' },
  contract_date: { title: '契約日' },
  cancellation_date: { title: '解約日' },
  valid_member_flag: { title: '有効会員フラグ(AGRDTE,KYKDTE)' },
  contract_update_day: { title: '変更日（契約データ）' },
  transaction_purpose: { title: '取引目的' },
  transaction_purpose_other: { title: '取引目的（その他）' },
  occupation: { title: '職業' },
  occupation_other: { title: '職業（その他）' },
  data_entry_date: { title: 'データ基準日' },
  postal_code: { title: '郵便番号' },
  address1: { title: '漢字住所1' },
  address2: { title: '漢字住所2' },
  telephone: { title: '電話番号' },
  mobile: { title: '携帯電話番号' },
  customer_update_day: { title: '変更日（顧客データ）' },
  kana_name: { title: 'ｶﾅ英字氏名' },
  kanji_name: { title: '漢字氏名' },
  emboss: { title: 'エンボスローマ字' },
  gender: { title: '性別区分' },
  birthday: { title: '生年月日' },
  card_expiration: { title: 'カード有効期限' },
  last_good_through: { title: 'カード前有効期限' },
  data_created_at: { title: 'データ作成日' },
  application_date: { title: '申込日' },
  card_issuance_instruction_date: { title: 'カード発行指示日' },
  card_shipping_date: { title: 'ｶｰﾄﾞ送付日' },
  link_origin: { title: '遷移元提携先情報' },
  rankup_date: { title: 'ランクアップ日' },
  card_issuance_date: { title: 'カード作成依頼日' },
  account_balance: { title: 'プリペイド口座残高' },
  pid: { title: 'pid' },
  country: { title: '国籍' },
  zairyuuShikaku: { title: '在留資格' },
  zairyuOther: { title: '在留資格（その他）' },
  prefecture: { title: '居住地' },
  created_at_choysan: { title: '登録日' },
  redirectId: { title: 'redirectId' },
  source: { title: 'source' },
  status: { title: 'status' },
  firstname: { title: 'Firstname' },
  lastname: { title: 'Lastname' },
  middlename: { title: 'Middlename' },
}
const _verificationFields = [
  "date_created",
  "data_created_at",
  "contract_number",
  "customer_number",
  "entry_number",
  "identification",
  "representative_contract_number",
  "popinfoId",
  "branch_number",
  "account_type",
  "account_number",
  "account_number_branch",
  "authentication_a",
  "a_date_confirmation",
  "authentication_b",
  "b_date_confirmation",
  "brand_id",
  "grade_id",
  "card_type",
  "usage_limit_1_time",
  "usage_limit_day",
  "usage_limit_month",
  "usage_limit_1_time_overseas",
  "usage_limit_day_overseas",
  "usage_limit_month_overseas",
  "withdraw_limit_1_overseas",
  "withdraw_limit_day_overseas",
  "withdraw_limit_month_overseas",
  "contract_date",
  "cancellation_date",
  "valid_member_flag",
  "contract_update_day",
  "transaction_purpose",
  "transaction_purpose_other",
  "occupation",
  "occupation_other",
  "data_entry_date",
  "postal_code",
  "address1",
  "address2",
  "telephone",
  "mobile",
  "customer_update_day",
  "kana_name",
  "kanji_name",
  "emboss",
  "gender",
  "birthday",
  "card_expiration",
  "last_good_through",
  "application_date",
  "card_issuance_instruction_date",
  "card_shipping_date",
  "link_origin",
  "rankup_date",
  "card_issuance_date",
  "domestic_shopping_amount",
  "domestic_shopping_number",
  "domestic_shopping_flag",
  "overseas_shopping_amount",
  "overseas_shopping_number",
  "overseas_shopping_flag",
  "qr_payment_amount",
  "qr_payment_number",
  "qr_payment_flag",
  "atm_withdrawal_amount",
  "atm_withdrawal_number",
  "atm_withdrawal_flag",
  "otasuke_charge_deposit_amount",
  "otasuke_charge_deposit_number",
  "otasuke_charge_deposit_flag",
  "otasuke_charge_repayment_amount",
  "otasuke_charge_repayment_number",
  "otasuke_charge_repayment_flag",
  "deposit_gather_amount",
  "deposit_gather_number",
  "deposit_gather_flag",
  "withdrawal_gather_amount",
  "withdrawal_gather_number",
  "withdrawal_gather_flag",
  "credit_charge_amount",
  "credit_charge_number",
  "credit_charge_flag",
  "atm_deposit_amount",
  "atm_deposit_number",
  "atm_deposit_flag",
  "transfer_deposit_amount",
  "transfer_deposit_number",
  "transfer_deposit_flag",
  "main_sub_transfer_deposit_amount",
  "main_sub_transfer_deposit_number",
  "main_sub_transfer_deposit_flag",
  "main_sub_transfer_withdrawal_amount",
  "main_sub_transfer_withdrawal_number",
  "main_sub_transfer_withdrawal_flag",
  "remittance_between_individuals_deposit_amount",
  "remittance_between_individuals_deposit_number",
  "remittance_between_individuals_deposit_flag",
  "remittance_between_individuals_withdrawal_amount",
  "remittance_between_individuals_withdrawal_number",
  "remittance_between_individuals_withdrawal_flag",
  "atm_fee_amount",
  "atm_fee_number",
  "atm_fee_flag",
  "overseas_fee_amount",
  "overseas_fee_number",
  "overseas_fee_flag",
  "card_issuing_fee_amount",
  "card_issuing_fee_number",
  "card_issuing_fee_flag",
  "card_reissue_fee_amount",
  "card_reissue_fee_number",
  "card_reissue_fee_flag",
  "pin_notification_fee_amount",
  "pin_notification_fee_number",
  "pin_notification_fee_flag",
  "report_fee_amount",
  "report_fee_number",
  "report_fee_flag",
  "annual_fede_amount",
  "annual_fede_number",
  "annual_fede_flag",
  "renewal_fee_amount",
  "renewal_fee_number",
  "renewal_fee_flag",
  "deposit_fee_amount",
  "deposit_fee_number",
  "deposit_fee_flag",
  "otasuke_charge_fee_amount",
  "otasuke_charge_fee_number",
  "otasuke_charge_fee_flag",
  "atm_deposit_fee_amount",
  "atm_deposit_fee_flag",
  "atm_deposit_fee_number",
  "credit_charge_fee_amount",
  "credit_charge_fee_number",
  "credit_charge_fee_flag",
  "atm_deposit_fee_amount2",
  "atm_deposit_fee_number2",
  "atm_deposit_fee_flag2",
  "refund_fee_amount",
  "refund_fee_number",
  "refund_fee_flag",
  "account_balance",
  "settlement_iss_fee"
];
const _fields = {
  "実績年月": "date_created",
  "契約番号": "contract_number",
  "顧客番号": "customer_number",
  "申込番号": "entry_number",
  "名寄せ識別": "identification",
  "代表契約番号": "representative_contract_number",
  "POPINFOID": "popinfoId",
  "支店ｺｰﾄﾞ": "branch_number",
  "預金種別": "account_type",
  "口座番号": "account_number",
  "口座番号枝番": "account_number_branch",
  "本人確認資料A種別": "authentication_a",
  "本人確認資料A確認日": "a_date_confirmation",
  "本人確認資料B種別": "authentication_b",
  "本人確認資料B確認日": "b_date_confirmation",
  "ﾌﾞﾗﾝﾄﾞID": "brand_id",
  "ｸﾞﾚｰﾄﾞID": "grade_id",
  "ｶｰﾄﾞ種類": "card_type",
  "カード種類": "card_type",
  "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1回)": "usage_limit_1_time",
  "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1日)": "usage_limit_day",
  "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1ヶ月)": "usage_limit_month",
  "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1回)": "usage_limit_1_time_overseas",
  "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1日)": "usage_limit_day_overseas",
  "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1ヶ月)": "usage_limit_month_overseas",
  "利用限度額(海外現金引出_1回)": "withdraw_limit_1_overseas",
  "利用限度額(海外現金引出_1日)": "withdraw_limit_day_overseas",
  "利用限度額(海外現金引出_1ヶ月)": "withdraw_limit_month_overseas",
  "契約日": "contract_date",
  "解約日": "cancellation_date",
  "有効会員フラグ(AGRDTE,KYKDTE)": "valid_member_flag",
  "変更日（契約データ）": "contract_update_day",
  "取引目的": "transaction_purpose",
  "取引目的（その他）": "transaction_purpose_other",
  "職業": "occupation",
  "職業（その他）": "occupation_other",
  "データ基準日": "data_entry_date",
  "郵便番号": "postal_code",
  "漢字住所1": "address1",
  "漢字住所2": "address2",
  "電話番号": "telephone",
  "携帯電話番号": "mobile",
  "変更日（顧客データ）": "customer_update_day",
  "ｶﾅ英字氏名": "kana_name",
  "漢字氏名": "kanji_name",
  "ｴﾝﾎﾞｽﾛｰﾏ字": "emboss",
  "性別区分": "gender",
  "生年月日": "birthday",
  "ｶｰﾄﾞ有効期限": "card_expiration",
  "ｶｰﾄﾞ前有効期限": "last_good_through",
  "申込日": "application_date",
  "ｶｰﾄﾞ発行指示日": "card_issuance_instruction_date",
  "ｶｰﾄﾞ送付日": "card_shipping_date",
  "遷移元提携先情報": "link_origin",
  "ランクアップ日": "rankup_date",
  "カード作成依頼日": "card_issuance_date",
  "国内ショッピング金額(摘要区分(01)_売上区分(03_04_05_06))": "domestic_shopping_amount",
  "国内ショッピング件数(摘要区分(01)_売上区分(03_04_05_06))": "domestic_shopping_number",
  "国内ショッピングフラグ": "domestic_shopping_flag",
  "海外ショッピング金額(摘要区分(02)_売上区分(03_04_05_06))": "overseas_shopping_amount",
  "海外ショッピング件数(摘要区分(02)_売上区分(03_04_05_06))": "overseas_shopping_number",
  "海外ショッピングフラグ": "overseas_shopping_flag",
  "QR決済金額(摘要区分(63_64)_入金区分(01_02_03_04))": "qr_payment_amount",
  "QR決済件数(摘要区分(63_64)_入金区分(01_02_03_04))": "qr_payment_number",
  "QR決済フラグ": "qr_payment_flag",
  "ATM(出金)金額(摘要区分(66)_入金区分(03_04))": "atm_withdrawal_amount",
  "ATM(出金)件数(摘要区分(66)_入金区分(03_04))": "atm_withdrawal_number",
  "ATM(出金)フラグ": "atm_withdrawal_flag",
  "おたすけチャージ(入金)金額(摘要区分(60)_入金区分(01_02))": "otasuke_charge_deposit_amount",
  "おたすけチャージ(入金)件数(摘要区分(60)_入金区分(01_02))": "otasuke_charge_deposit_number",
  "おたすけチャージ(入金))フラグ": "otasuke_charge_deposit_flag",
  "おたすけチャージ(返済)金額(摘要区分(61_62)_入金区分(01_02))": "otasuke_charge_repayment_amount",
  "おたすけチャージ(返済)件数(摘要区分(61_62)_入金区分(01_02))": "otasuke_charge_repayment_number",
  "おたすけチャージ(返済)フラグ": "otasuke_charge_repayment_flag",
  "入金(一括)金額(摘要区分(75)_売上区分(03_04))": "deposit_gather_amount",
  "入金(一括)件数(摘要区分(75)_売上区分(03_04))": "deposit_gather_number",
  "入金(一括)フラグ": "deposit_gather_flag",
  "出金(一括)金額(摘要区分(76)_売上区分(03_04))": "withdrawal_gather_amount",
  "出金(一括)件数(摘要区分(76)_売上区分(03_04))": "withdrawal_gather_number",
  "出金(一括)フラグ": "withdrawal_gather_flag",
  "クレジットチャージ金額(摘要区分(47)_入金区分(01_02))": "credit_charge_amount",
  "クレジットチャージ件数(摘要区分(47)_入金区分(01_02))": "credit_charge_number",
  "クレジットチャージフラグ": "credit_charge_flag",
  "ATM入金金額(摘要区分(65)_入金区分(01_02))": "atm_deposit_amount",
  "ATM入金件数(摘要区分(65)_入金区分(01_02))": "atm_deposit_number",
  "ATM入金フラグ": "atm_deposit_flag",
  "振込金額(摘要区分(14)_入金区分(01_02))": "transfer_deposit_amount",
  "振込件数(摘要区分(14)_入金区分(01_02))": "transfer_deposit_number",
  "振込フラグ": "transfer_deposit_flag",
  "メインサブ間入金金額(摘要区分(67)_入金区分(01_02))": "main_sub_transfer_deposit_amount",
  "メインサブ間入金件数(摘要区分(67)_入金区分(01_02))": "main_sub_transfer_deposit_number",
  "メインサブ間入金フラグ": "main_sub_transfer_deposit_flag",
  "メインサブ間出金金額(摘要区分(68)_入金区分(03_04))": "main_sub_transfer_withdrawal_amount",
  "メインサブ間出金件数(摘要区分(68)_入金区分(03_04))": "main_sub_transfer_withdrawal_number",
  "メインサブ間出金フラグ": "main_sub_transfer_withdrawal_flag",
  "個人間入金金額(摘要区分(69)_入金区分(01_02))": "remittance_between_individuals_deposit_amount",
  "個人間入金件数(摘要区分(69)_入金区分(01_02))": "remittance_between_individuals_deposit_number",
  "個人間入金フラグ": "remittance_between_individuals_deposit_flag",
  "個人間出金金額(摘要区分(70)_入金区分(03_04))": "remittance_between_individuals_withdrawal_amount",
  "個人間出金件数(摘要区分(70)_入金区分(03_04))": "remittance_between_individuals_withdrawal_number",
  "個人間出金フラグ": "remittance_between_individuals_withdrawal_flag",
  "未使用項目": "free",
  "決済ATM手数料金額(売上区分(03_04_05_06))": "atm_fee_amount",
  "決済ATM手数料件数(売上区分(03_04_05_06))": "atm_fee_number",
  "決済ATM手数料フラグ": "atm_fee_flag",
  "決済海外取扱手数料金額(売上区分(03_04_05_06))": "overseas_fee_amount",
  "決済海外取扱手数料件数(売上区分(03_04_05_06))": "overseas_fee_number",
  "決済海外取扱手数料フラグ": "overseas_fee_flag",
  "カード初回発行手数料金額(摘要区分(52)_入金区分(03_04))": "card_issuing_fee_amount",
  "カード初回発行手数料件数(摘要区分(52)_入金区分(03_04))": "card_issuing_fee_number",
  "カード初回発行手数料フラグ": "card_issuing_fee_flag",
  "カード再発行手数料金額(摘要区分(21)_入金区分(03_04))": "card_reissue_fee_amount",
  "カード再発行手数料件数(摘要区分(21)_入金区分(03_04))": "card_reissue_fee_number",
  "カード再発行手数料フラグ": "card_reissue_fee_flag",
  "暗号番号通知手数料金額(摘要区分(24)_入金区分(03_04))": "pin_notification_fee_amount",
  "暗号番号通知手数料件数(摘要区分(24)_入金区分(03_04))": "pin_notification_fee_number",
  "暗号番号通知手数料フラグ": "pin_notification_fee_flag",
  "払明細発行手数料金額(摘要区分(22)_入金区分(03_04))": "report_fee_amount",
  "払明細発行手数料件数(摘要区分(22)_入金区分(03_04))": "report_fee_number",
  "払明細発行手数料フラグ": "report_fee_flag",
  "年会費金額(摘要区分(06)_入金区分(03_04))": "annual_fede_amount",
  "年会費件数(摘要区分(06)_入金区分(03_04))": "annual_fede_number",
  "年会費フラグ": "annual_fede_flag",
  "有効期限更新時再発行手数料金額(摘要区分(23)_入金区分(03_04))": "renewal_fee_amount",
  "有効期限更新時再発行手数料件数(摘要区分(23)_入金区分(03_04))": "renewal_fee_number",
  "有効期限更新時再発行手数料フラグ": "renewal_fee_flag",
  "入金手数料金額(摘要区分(26)_入金区分(03_04))": "deposit_fee_amount",
  "入金手数料件数(摘要区分(26)_入金区分(03_04))": "deposit_fee_number",
  "入金手数料フラグ": "deposit_fee_flag",
  "おたすけチャージ手数料金額(摘要区分(77)_入金区分(03_04))": "otasuke_charge_fee_amount",
  "おたすけチャージ手数料件数(摘要区分(77)_入金区分(03_04))": "otasuke_charge_fee_number",
  "おたすけチャージ手数料フラグ": "otasuke_charge_fee_flag",
  "ATM入金手数料金額(摘要区分(78)_入金区分(03_04))": "atm_deposit_fee_amount",
  "ATM入金手数料件数(摘要区分(78)_入金区分(03_04))": "atm_deposit_fee_flag",
  "ATM入金手数料フラグ": "atm_deposit_fee_number",
  "クレジットチャージ手数料金額(摘要区分(79)_入金区分(03_04))": "credit_charge_fee_amount",
  "クレジットチャージ手数料件数(摘要区分(79)_入金区分(03_04))": "credit_charge_fee_number",
  "クレジットチャージ手数料フラグ": "credit_charge_fee_flag",
  "ATM出金手数料金額(摘要区分(80)_入金区分(03_04))": "atm_deposit_fee_amount2",
  "ATM出金手数料件数(摘要区分(80)_入金区分(03_04))": "atm_deposit_fee_number2",
  "ATM出金手数料フラグ": "atm_deposit_fee_flag2",
  "払い戻し金額(摘要区分(27)_入金区分(03_04))": "refund_fee_amount",
  "払い戻し件数(摘要区分(27)_入金区分(03_04))": "refund_fee_number",
  "払い戻しフラグ": "refund_fee_flag",
  "プリペイド口座残高": "account_balance",
  "暗証番号通知手数料フラグ": "pin_notification_fee_flag",
  "暗証番号通知手数料金額(摘要区分(24)_入金区分(03_04))": "pin_notification_fee_amount",
  "暗証番号通知手数料件数(摘要区分(24)_入金区分(03_04))": "pin_notification_fee_number",
  "有効会員フラグ(AGRDTE_KYKDTE)": "valid_member_flag",
  "決済ISS手数料及び決済現地手数料(未使用)": "settlement_iss_fee",
  "データ作成日": "data_created_at",
  "国内ショッピング": "domestic_shopping_amount",
  "海外ショッピング": "overseas_shopping_amount",
  "出金（一括）": "withdrawal_gather_amount",
  "QR決済": "qr_payment_amount",
  "ATM出金": "atm_deposit_fee_amount2",
  "メインサブ出金": "main_sub_transfer_withdrawal_amount",
  "個人間出金": "remittance_between_individuals_withdrawal_amount",
  "おたすけチャージ（入金）": "otasuke_charge_deposit_amount",
  "おたすけチャージ（返済）": "otasuke_charge_repayment_amount",
  "クレジットチャージ": "credit_charge_amount",
  "ATM入金": "atm_deposit_amount",
  "振込": "transfer_deposit_amount",
  "メインサブ間入金": "main_sub_transfer_deposit_amount",
  "個人間入金": "remittance_between_individuals_deposit_amount",
  "date_created": "実績年月",
  "data_created_at": "データ作成日",
  "contract_number": "契約番号",
  "customer_number": "顧客番号",
  "entry_number": "申込番号",
  "identification": "名寄せ識別",
  "representative_contract_number": "代表契約番号",
  "popinfoId": "POPINFOID",
  "branch_number": "支店ｺｰﾄﾞ",
  "account_type": "預金種別",
  "account_number": "口座番号",
  "account_number_branch": "口座番号枝番",
  "authentication_a": "本人確認資料A種別",
  "a_date_confirmation": "本人確認資料A確認日",
  "authentication_b": "本人確認資料B種別",
  "b_date_confirmation": "本人確認資料B確認日",
  "brand_id": "ブランドID",
  "grade_id": "グレードID",
  "card_type": "カード種類",
  "usage_limit_1_time": "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1回)",
  "usage_limit_day": "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1日)",
  "usage_limit_month": "利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ_1ヶ月)",
  "usage_limit_1_time_overseas": "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1回)",
  "usage_limit_day_overseas": "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1日)",
  "usage_limit_month_overseas": "利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ_1ヶ月)",
  "withdraw_limit_1_overseas": "利用限度額(海外現金引出_1回)",
  "withdraw_limit_day_overseas": "利用限度額(海外現金引出_1日)",
  "withdraw_limit_month_overseas": "利用限度額(海外現金引出_1ヶ月)",
  "contract_date": "契約日",
  "cancellation_date": "解約日",
  "valid_member_flag": "有効会員フラグ",
  "contract_update_day": "変更日（契約データ）",
  "transaction_purpose": "取引目的",
  "transaction_purpose_other": "取引目的（その他）",
  "occupation": "職業",
  "occupation_other": "職業（その他）",
  "data_entry_date": "データ基準日",
  "postal_code": "郵便番号",
  "address1": "漢字住所1",
  "address2": "漢字住所2",
  "telephone": "電話番号",
  "mobile": "携帯電話番号",
  "customer_update_day": "変更日（顧客データ）",
  "kana_name": "カナ英字氏名",
  "kanji_name": "漢字氏名",
  "emboss": "エンボスローマ字",
  "gender": "性別区分",
  "birthday": "生年月日",
  "card_expiration": "カード有効期限",
  "last_good_through": "カード前有効期限",
  "created_at": "Firebaseデータ作成日",
  "application_date": "申込日",
  "card_issuance_instruction_date": "カード発行指示日",
  "card_shipping_date": "カード送付日",
  "link_origin": "遷移元提携先情報",
  "rankup_date": "ランクアップ日",
  "card_issuance_date": "カード作成依頼日",
  "domestic_shopping_amount": "国内ショッピング金額(摘要区分(01)_売上区分(03_04_05_06))",
  "domestic_shopping_number": "国内ショッピング件数(摘要区分(01)_売上区分(03_04_05_06))",
  "domestic_shopping_flag": "国内ショッピングフラグ",
  "overseas_shopping_amount": "海外ショッピング金額(摘要区分(02)_売上区分(03_04_05_06))",
  "overseas_shopping_number": "海外ショッピング件数(摘要区分(02)_売上区分(03_04_05_06))",
  "overseas_shopping_flag": "海外ショッピングフラグ",
  "qr_payment_amount": "QR決済金額(摘要区分(63_64)_入金区分(01_02_03_04))",
  "qr_payment_number": "QR決済件数(摘要区分(63_64)_入金区分(01_02_03_04))",
  "qr_payment_flag": "QR決済フラグ",
  "atm_withdrawal_amount": "ATM(出金)金額(摘要区分(66)_入金区分(03_04))",
  "atm_withdrawal_number": "ATM(出金)件数(摘要区分(66)_入金区分(03_04))",
  "atm_withdrawal_flag": "ATM(出金)フラグ",
  "otasuke_charge_deposit_amount": "おたすけチャージ(入金)金額(摘要区分(60)_入金区分(01_02))",
  "otasuke_charge_deposit_number": "おたすけチャージ(入金)件数(摘要区分(60)_入金区分(01_02))",
  "otasuke_charge_deposit_flag": "おたすけチャージ(入金))フラグ",
  "otasuke_charge_repayment_amount": "おたすけチャージ(返済)金額(摘要区分(61_62)_入金区分(01_02))",
  "otasuke_charge_repayment_number": "おたすけチャージ(返済)件数(摘要区分(61_62)_入金区分(01_02))",
  "otasuke_charge_repayment_flag": "おたすけチャージ(返済)フラグ",
  "deposit_gather_amount": "入金(一括)金額(摘要区分(75)_売上区分(03_04))",
  "deposit_gather_number": "入金(一括)件数(摘要区分(75)_売上区分(03_04))",
  "deposit_gather_flag": "入金(一括)フラグ",
  "withdrawal_gather_amount": "出金(一括)金額(摘要区分(76)_売上区分(03_04))",
  "withdrawal_gather_number": "出金(一括)件数(摘要区分(76)_売上区分(03_04))",
  "withdrawal_gather_flag": "出金(一括)フラグ",
  "credit_charge_amount": "クレジットチャージ金額(摘要区分(47)_入金区分(01_02))",
  "credit_charge_number": "クレジットチャージ件数(摘要区分(47)_入金区分(01_02))",
  "credit_charge_flag": "クレジットチャージフラグ",
  "atm_deposit_amount": "ATM入金金額(摘要区分(65)_入金区分(01_02))",
  "atm_deposit_number": "ATM入金件数(摘要区分(65)_入金区分(01_02))",
  "atm_deposit_flag": "ATM入金フラグ",
  "transfer_deposit_amount": "振込金額(摘要区分(14)_入金区分(01_02))",
  "transfer_deposit_number": "振込件数(摘要区分(14)_入金区分(01_02))",
  "transfer_deposit_flag": "振込フラグ",
  "main_sub_transfer_deposit_amount": "メインサブ間入金金額(摘要区分(67)_入金区分(01_02))",
  "main_sub_transfer_deposit_number": "メインサブ間入金件数(摘要区分(67)_入金区分(01_02))",
  "main_sub_transfer_deposit_flag": "メインサブ間入金フラグ",
  "main_sub_transfer_withdrawal_amount": "メインサブ間出金金額(摘要区分(68)_入金区分(03_04))",
  "main_sub_transfer_withdrawal_number": "メインサブ間出金件数(摘要区分(68)_入金区分(03_04))",
  "main_sub_transfer_withdrawal_flag": "メインサブ間出金フラグ",
  "remittance_between_individuals_deposit_amount": "個人間入金金額(摘要区分(69)_入金区分(01_02))",
  "remittance_between_individuals_deposit_number": "個人間入金件数(摘要区分(69)_入金区分(01_02))",
  "remittance_between_individuals_deposit_flag": "個人間入金フラグ",
  "remittance_between_individuals_withdrawal_amount": "個人間出金金額(摘要区分(70)_入金区分(03_04))",
  "remittance_between_individuals_withdrawal_number": "個人間出金件数(摘要区分(70)_入金区分(03_04))",
  "remittance_between_individuals_withdrawal_flag": "個人間出金フラグ",
  "free": "未使用項目",
  "atm_fee_amount": "決済ATM手数料金額(売上区分(03_04_05_06))",
  "atm_fee_number": "決済ATM手数料件数(売上区分(03_04_05_06))",
  "atm_fee_flag": "決済ATM手数料フラグ",
  "overseas_fee_amount": "決済海外取扱手数料金額(売上区分(03_04_05_06))",
  "overseas_fee_number": "決済海外取扱手数料件数(売上区分(03_04_05_06))",
  "overseas_fee_flag": "決済海外取扱手数料フラグ",
  "card_issuing_fee_amount": "カード初回発行手数料金額(摘要区分(52)_入金区分(03_04))",
  "card_issuing_fee_number": "カード初回発行手数料件数(摘要区分(52)_入金区分(03_04))",
  "card_issuing_fee_flag": "カード初回発行手数料フラグ",
  "card_reissue_fee_amount": "カード再発行手数料金額(摘要区分(21)_入金区分(03_04))",
  "card_reissue_fee_number": "カード再発行手数料件数(摘要区分(21)_入金区分(03_04))",
  "card_reissue_fee_flag": "カード再発行手数料フラグ",
  "pin_notification_fee_amount": "暗証番号通知手数料金額(摘要区分(24)_入金区分(03_04))",
  "pin_notification_fee_number": "暗証番号通知手数料件数(摘要区分(24)_入金区分(03_04))",
  "pin_notification_fee_flag": "暗証番号通知手数料フラグ",
  "report_fee_amount": "払明細発行手数料金額(摘要区分(22)_入金区分(03_04))",
  "report_fee_number": "払明細発行手数料件数(摘要区分(22)_入金区分(03_04))",
  "report_fee_flag": "払明細発行手数料フラグ",
  "annual_fede_amount": "年会費金額(摘要区分(06)_入金区分(03_04))",
  "annual_fede_number": "年会費件数(摘要区分(06)_入金区分(03_04))",
  "annual_fede_flag": "年会費フラグ",
  "renewal_fee_amount": "有効期限更新時再発行手数料金額(摘要区分(23)_入金区分(03_04))",
  "renewal_fee_number": "有効期限更新時再発行手数料件数(摘要区分(23)_入金区分(03_04))",
  "renewal_fee_flag": "有効期限更新時再発行手数料フラグ",
  "deposit_fee_amount": "入金手数料金額(摘要区分(26)_入金区分(03_04))",
  "deposit_fee_number": "入金手数料件数(摘要区分(26)_入金区分(03_04))",
  "deposit_fee_flag": "入金手数料フラグ",
  "otasuke_charge_fee_amount": "おたすけチャージ手数料金額(摘要区分(77)_入金区分(03_04))",
  "otasuke_charge_fee_number": "おたすけチャージ手数料件数(摘要区分(77)_入金区分(03_04))",
  "otasuke_charge_fee_flag": "おたすけチャージ手数料フラグ",
  "atm_deposit_fee_amount": "ATM入金手数料金額(摘要区分(78)_入金区分(03_04))",
  "atm_deposit_fee_flag": "ATM入金手数料件数(摘要区分(78)_入金区分(03_04))",
  "atm_deposit_fee_number": "ATM入金手数料フラグ",
  "credit_charge_fee_amount": "クレジットチャージ手数料金額(摘要区分(79),入金区分(03_04))",
  "credit_charge_fee_number": "クレジットチャージ手数料件数(摘要区分(79),入金区分(03_04))",
  "credit_charge_fee_flag": "クレジットチャージ手数料フラグ",
  "atm_deposit_fee_amount2": "ATM出金手数料金額(摘要区分(80)_入金区分(03_04))",
  "atm_deposit_fee_number2": "ATM出金手数料件数(摘要区分(80)_入金区分(03_04))",
  "atm_deposit_fee_flag2": "ATM出金手数料フラグ",
  "refund_fee_amount": "払い戻し金額(摘要区分(27)_入金区分(03_04))",
  "refund_fee_number": "払い戻し件数(摘要区分(27)_入金区分(03_04))",
  "refund_fee_flag": "払い戻しフラグ",
  "account_balance": "プリペイド口座残高",
  "settlement_iss_fee": "決済ISS手数料及び決済現地手数料(未使用)",
  "middle_name_en": "MIDDLE NAME",
  "last_name_en": "LAST NAME",
  "first_name_en": "FIRST NAME",
  "nickname": "ニックネーム",
  "pid": "パートナーID",
  "phone": "携帯電話番号",
  "redirect": "リダイレクト先",
  "redirectId": "リダイレクトID",
  "updated_at": "updated_at",
  "source": "リンク元URL",
  "sex": "性別",
  "country_code": "国籍",
  "pref_code": "居住地",
  "UID": "UID",
  "status": "status",
  "zairyuuShikaku": "zairyuuShikaku",
  "zairyuOther": "zairyuOther",
};

const _transactionsFieldsMapping = {
  "国内ショッピング": "01",
  "海外ショッピング": "02",
  "出金（一括）": "76",
  "QR決済": "63",
  "ATM出金": "66",
  "メインサブ出金": "68",
  "個人間出金": "70",
  "おたすけチャージ（入金）": "60",
  "おたすけチャージ（返済）": "61",
  "クレジットチャージ": "47",
  "ATM入金": "65",
  "振込": "14",
  "メインサブ間入金": "67",
  "個人間入金": "69",
}
/**
 * csvファイル出力時の形式定義
 */
const _tsvFormat = {
  /**
   * 会員情報
   */
  userInfo: {
    fileName: "顧客情報",
    labels: {
      id: { title: 'ID' },
      lastNameEn: { title: '姓_英字' },
      firstNameEn: { title: '名_英字' },
      middleNameEn: { title: 'ミドルネーム_英字' },
      sex: { title: '性別' },
      birthday: { title: '生年月日' },
      countryCode: { title: '国コード' },
      prefCode: { title: '都道府県コード' },
      nickname: { title: 'ニックネーム' },
      createdAt: { title: '登録日時' },
      updatedAt: { title: '更新日時' }
    },
  },
  jobsInfo: {
    fileName: "仕事情報",
    labels: {
      id: { title: 'ID' },
      dispStatus: { title: '表示ステータス' },
      summary: { title: '仕事概要' },
      applyUrl: { title: '申し込みURL' },
      prefCode: { title: '都道府県コード' },
      salaryFrom: { title: '給与_FROM' },
      salaryTo: { title: '給与_TO' },
      japLevel: { title: '日本語レベルコード' },
      hour1F: { title: '勤務時間1_FROM' },
      hour1T: { title: '勤務時間1_TO' },
      hour1W: { title: '勤務時間1_WORD' },
      hour2F: { title: '勤務時間2_FROM' },
      hour2T: { title: '勤務時間2_TO' },
      hour2W: { title: '勤務時間2_WORD' },
      hour3F: { title: '勤務時間3_FROM' },
      hour3T: { title: '勤務時間3_TO' },
      hour3W: { title: '勤務時間3_WORD' },
      nearSta1: { title: '最寄駅1' },
      nearSta1W: { title: '最寄駅1_文言' },
      nearSta2: { title: '最寄駅2' },
      nearSta2W: { title: '最寄駅2_文言' },
      nearSta3: { title: '最寄駅3' },
      nearSta3W: { title: '最寄駅3_文言' },
      other: { title: 'その他条件/PR' },
      empTypeName: { title: '雇用形態' },
      createdAt: { title: '登録日時' },
      updatedAt: { title: '更新日時' }
    },
  },
  jobApplyInfo: {
    fileName: "仕事応募履歴",
    labels: {
      id: { title: '仕事応募ID' },
      jobId: { title: '仕事ID' },
      userId: { title: 'ユーザーID' },
      applyAt: { title: '応募日時' },
    },
  },
  jobViewInfo: {
    fileName: "仕事閲覧履歴",
    labels: {
      id: { title: '仕事詳細閲覧ID' },
      jobId: { title: '仕事ID' },
      userId: { title: 'ユーザーID' },
      browseAt: { title: '閲覧日時' },
    },
  },
  serviceLinkInfo: {
    fileName: "サービスリンク履歴",
    labels: {
      id: { title: 'サービスリンククリックID' },
      userId: { title: 'ユーザーID' },
      name: { title: 'サービス名' },
      clickedAt: { title: 'クリック日時' },
    },
  },
  logInfo: {
    fileName: "UserLogs",
    labels: {
      id: { title: 'LogId' },
      createdAt: { title: '作成日時' },
      type: { title: 'Type' },
      uid: { title: 'UserId' },
      pid: { title: 'PartnerId' },
      redirectId: { title: 'RedirectId' },
      source: { title: 'Source' }
    }
  },
  userListInfo: {
    fileName: "UserList",
    labels: {
      id: { title: 'ID' },
      phoneCountryCode: { title: '携帯電話国番号' },
      phone: { title: '携帯電話番号' },
      lastNameEn: { title: '姓_英字' },
      firstNameEn: { title: '名_英字' },
      middleNameEn: { title: 'ミドルネーム_英字' },
      sex: { title: '性別' },
      birthday: { title: '生年月日' },
      countryCode: { title: '国籍' },
      prefCode: { title: '居住地' },
      zairyu: { title: '在留資格' },
      zairyuOther: { title: '在留資格その他' },
      status: { title: 'ステータス' },
      pid: { title: 'PartnerId' },
      redirectId: { title: 'RedirectId' },
      source: { title: 'Source' },
      os: { title: "端末情報" },
      nickname: { title: 'ニックネーム' },
      createdAt: { title: '登録日時' },
      updatedAt: { title: '更新日時' }
    }
  },
  bankitInfo: {
    fileName: "BankitUsers",
    labels: {
      契約番号: { title: '契約番号' },
      代表契約番号: { title: '代表契約番号' },
      電話番号: { title: '電話番号' },
      携帯電話番号: { title: '携帯電話番号' },
      カナ英字氏名: { title: 'カナ英字氏名' },
      漢字氏名: { title: '漢字氏名' },
      POPINFOID: { title: 'POPINFOID' }
    },
  },
  masterData: {
    fileName: "MasterData",
    labels: {
      contract_number: { title: "契約番号" },
      customer_number: { title: '顧客番号' },
      entry_number: { title: '申込番号' },
      identification: { title: '名寄せ識別' },
      representative_contract_number: { title: '代表契約番号' },
      branch_number: { title: '支店ｺｰﾄﾞ' },
      account_type: { title: '預金種別' },
      account_number: { title: '口座番号' },
      account_number_branch: { title: '口座番号枝番' },
      authentication_a: { title: '本人確認資料A種別' },
      a_date_confirmation: { title: '本人確認資料A確認日' },
      authentication_b: { title: '本人確認資料B種別' },
      b_date_confirmation: { title: '本人確認資料B確認日' },
      brand_id: { title: 'ﾌﾞﾗﾝﾄﾞID' },
      grade_id: { title: 'ｸﾞﾚｰﾄﾞID' },
      card_type: { title: 'ｶｰﾄﾞ種類' },
      usage_limit_1_time: { title: '利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ/1回)' },
      usage_limit_day: { title: '利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ/1日)' },
      usage_limit_month: { title: '利用限度額(国内ｼｮｯﾋﾟﾝｸﾞ/1ヶ月)' },
      usage_limit_1_time_overseas: { title: '利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ/1回)' },
      usage_limit_day_overseas: { title: '利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ/1日)' },
      usage_limit_month_overseas: { title: '利用限度額(海外ｼｮｯﾋﾟﾝｸﾞ/1ヶ月)' },
      withdraw_limit_1_overseas: { title: '利用限度額(海外現金引出/1回)' },
      withdraw_limit_day_overseas: { title: '利用限度額(海外現金引出/1日)' },
      withdraw_limit_month_overseas: { title: '利用限度額(海外現金引出/1ヶ月)' },
      contract_date: { title: '契約日' },
      cancellation_date: { title: '解約日' },
      valid_member_flag: { title: '有効会員フラグ(AGRDTE,KYKDTE)' },
      contract_update_day: { title: '変更日（契約データ）' },
      transaction_purpose: { title: '取引目的' },
      transaction_purpose_other: { title: '取引目的（その他）' },
      occupation: { title: '職業' },
      occupation_other: { title: '職業（その他）' },
      data_entry_date: { title: 'データ基準日' },
      postal_code: { title: '郵便番号' },
      address1: { title: '漢字住所1' },
      address2: { title: '漢字住所2' },
      telephone: { title: '電話番号' },
      mobile: { title: '携帯電話番号' },
      customer_update_day: { title: '変更日（顧客データ）' },
      kana_name: { title: 'ｶﾅ英字氏名' },
      kanji_name: { title: '漢字氏名' },
      emboss: { title: 'ｴﾝﾎﾞｽﾛｰﾏ字' },
      gender: { title: '性別区分' },
      birthday: { title: '生年月日' },
      card_expiration: { title: 'ｶｰﾄﾞ有効期限' },
      last_good_through: { title: 'ｶｰﾄﾞ前有効期限' },
      data_created_at: { title: 'データ作成日' },
      application_date: { title: '申込日' },
      card_issuance_instruction_date: { title: 'ｶｰﾄﾞ発行指示日' },
      card_shipping_date: { title: 'ｶｰﾄﾞ送付日' },
      link_origin: { title: '遷移元提携先情報' },
      rankup_date: { title: 'ランクアップ日' },
      card_issuance_date: { title: 'カード作成依頼日' },
      account_balance: { title: 'プリペイド口座残高' },
      //settlementData
      domestic_shopping_amount: { title: '国内ショッピング金額(摘要区分(01),売上区分(03,04,05,06))' },
      domestic_shopping_number: { title: '国内ショッピング件数(摘要区分(01),売上区分(03,04,05,06))' },
      domestic_shopping_flag: { title: '国内ショッピングフラグ' },
      overseas_shopping_amount: { title: '海外ショッピング金額(摘要区分(02),売上区分(03,04,05,06))' },
      overseas_shopping_number: { title: '海外ショッピング件数(摘要区分(02),売上区分(03,04,05,06))' },
      overseas_shopping_flag: { title: '海外ショッピングフラグ' },
      qr_payment_amount: { title: 'QR決済金額(摘要区分(63,64),入金区分(01,02,03,04))' },
      qr_payment_number: { title: 'QR決済件数(摘要区分(63,64),入金区分(01,02,03,04))' },
      qr_payment_flag: { title: 'QR決済フラグ' },
      atm_withdrawal_amount: { title: 'ATM(出金)金額(摘要区分(66),入金区分(03,04))' },
      atm_withdrawal_number: { title: 'ATM(出金)件数(摘要区分(66),入金区分(03,04))' },
      atm_withdrawal_flag: { title: 'ATM(出金)フラグ' },
      otasuke_charge_deposit_amount: { title: 'おたすけチャージ(入金)金額(摘要区分(60),入金区分(01,02))' },
      otasuke_charge_deposit_number: { title: 'おたすけチャージ(入金)件数(摘要区分(60),入金区分(01,02))' },
      otasuke_charge_deposit_flag: { title: 'おたすけチャージ(入金))フラグ' },
      otasuke_charge_repayment_amount: { title: 'おたすけチャージ(返済)金額(摘要区分(61,62),入金区分(01,02))' },
      otasuke_charge_repayment_number: { title: 'おたすけチャージ(返済)件数(摘要区分(61,62),入金区分(01,02))' },
      otasuke_charge_repayment_flag: { title: 'おたすけチャージ(返済)フラグ' },
      deposit_gather_amount: { title: '入金(一括)金額(摘要区分(75),売上区分(03,04))' },
      deposit_gather_number: { title: '入金(一括)件数(摘要区分(75),売上区分(03,04))' },
      deposit_gather_flag: { title: '入金(一括)フラグ' },
      withdrawal_gather_amount: { title: '出金(一括)金額(摘要区分(76),売上区分(03,04))' },
      withdrawal_gather_number: { title: '出金(一括)金額(摘要区分(76),売上区分(03,04))' },
      withdrawal_gather_flag: { title: '出金(一括)フラグ' },
      credit_charge_amount: { title: 'クレジットチャージ金額(摘要区分(47),入金区分(01,02))' },
      credit_charge_number: { title: 'クレジットチャージ件数(摘要区分(47),入金区分(01,02))' },
      credit_charge_flag: { title: 'クレジットチャージフラグ' },
      cashing_charge_amount: { title: 'キャッシングチャージ金額(摘要区分(84))' },
      cashing_charge_number: { title: 'キャッシングチャージ件数(摘要区分(84))' },
      cashing_charge_flag: { title: 'キャッシングチャージフラグ' },
      atm_deposit_amount: { title: 'ATM入金金額(摘要区分(65),入金区分(01,02))' },
      atm_deposit_number: { title: 'ATM入金件数(摘要区分(65),入金区分(01,02))' },
      atm_deposit_flag: { title: 'ATM入金フラグ' },
      transfer_deposit_amount: { title: '振込金額(摘要区分(14),入金区分(01,02))' },
      transfer_deposit_number: { title: '振込件数(摘要区分(14),入金区分(01,02))' },
      transfer_deposit_flag: { title: '振込フラグ' },
      main_sub_transfer_deposit_amount: { title: 'メインサブ間入金金額(摘要区分(67),入金区分(01,02))' },
      main_sub_transfer_deposit_number: { title: 'メインサブ間入金件数(摘要区分(67),入金区分(01,02))' },
      main_sub_transfer_deposit_flag: { title: 'メインサブ間入金フラグ' },
      main_sub_transfer_withdrawal_amount: { title: 'メインサブ間出金金額(摘要区分(68),入金区分(03,04))' },
      main_sub_transfer_withdrawal_number: { title: 'メインサブ間出金件数(摘要区分(68),入金区分(03,04))' },
      main_sub_transfer_withdrawal_flag: { title: 'メインサブ間出金フラグ' },
      remittance_between_individuals_deposit_amount: { title: '個人間入金金額(摘要区分(69),入金区分(01,02))' },
      remittance_between_individuals_deposit_number: { title: '個人間入金件数(摘要区分(69),入金区分(01,02))' },
      remittance_between_individuals_deposit_flag: { title: '個人間入金フラグ' },
      remittance_between_individuals_withdrawal_amount: { title: '個人間出金金額(摘要区分(70),入金区分(03,04))' },
      remittance_between_individuals_withdrawal_number: { title: '個人間出金件数(摘要区分(70),入金区分(03,04))' },
      remittance_between_individuals_withdrawal_flag: { title: '個人間出金フラグ' },
      atm_fee_amount: { title: '決済ATM手数料金額(売上区分(03,04,05,06))' },
      atm_fee_number: { title: '決済ATM手数料件数(売上区分(03,04,05,06))' },
      atm_fee_flag: { title: '決済ATM手数料フラグ' },
      overseas_fee_amount: { title: '決済海外取扱手数料金額(売上区分(03,04,05,06))' },
      overseas_fee_number: { title: '決済海外取扱手数料件数(売上区分(03,04,05,06))' },
      overseas_fee_flag: { title: '決済海外取扱手数料フラグ' },
      card_issuing_fee_amount: { title: 'カード初回発行手数料金額(摘要区分(52),入金区分(03,04))' },
      card_issuing_fee_number: { title: 'カード初回発行手数料金額(摘要区分(52),入金区分(03,04))' },
      card_issuing_fee_flag: { title: 'カード初回発行手数料フラグ' },
      card_reissue_fee_amount: { title: 'カード再発行手数料金額(摘要区分(21),入金区分(03,04))' },
      card_reissue_fee_number: { title: 'カード再発行手数料件数(摘要区分(21),入金区分(03,04))' },
      card_reissue_fee_flag: { title: 'カード再発行手数料フラグ' },
      pin_notification_fee_amount: { title: '暗号番号通知手数料金額(摘要区分(24),入金区分(03,04))' },
      pin_notification_fee_number: { title: '暗号番号通知手数料件数(摘要区分(24),入金区分(03,04))' },
      pin_notification_fee_flag: { title: '暗号番号通知手数料フラグ' },
      report_fee_amount: { title: '払明細発行手数料金額(摘要区分(22),入金区分(03,04))' },
      report_fee_number: { title: '払明細発行手数料件数(摘要区分(22),入金区分(03,04))' },
      report_fee_flag: { title: '払明細発行手数料フラグ' },
      annual_fede_amount: { title: '年会費金額(摘要区分(06),入金区分(03,04))' },
      annual_fede_number: { title: '年会費件数(摘要区分(06),入金区分(03,04))' },
      annual_fede_flag: { title: '年会費フラグ' },
      renewal_fee_amount: { title: '有効期限更新時再発行手数料金額(摘要区分(23),入金区分(03,04))' },
      renewal_fee_number: { title: '有効期限更新時再発行手数料件数(摘要区分(23),入金区分(03,04))' },
      renewal_fee_flag: { title: '有効期限更新時再発行手数料フラグ' },
      deposit_fee_amount: { title: '入金手数料金額(摘要区分(26),入金区分(03,04))' },
      deposit_fee_number: { title: '入金手数料件数(摘要区分(26),入金区分(03,04))' },
      deposit_fee_flag: { title: '入金手数料フラグ' },
      otasuke_charge_fee_amount: { title: 'おたすけチャージ手数料金額(摘要区分(77),入金区分(03,04))' },
      otasuke_charge_fee_number: { title: 'おたすけチャージ手数料金額(摘要区分(77),入金区分(03,04))' },
      otasuke_charge_fee_flag: { title: 'おたすけチャージ手数料フラグ' },
      atm_deposit_fee_amount: { title: 'ATM入金手数料金額(摘要区分(78),入金区分(03,04))' },
      atm_deposit_fee_number: { title: 'ATM入金手数料件数(摘要区分(78),入金区分(03,04))' },
      atm_deposit_fee_flag: { title: 'ATM入金手数料フラグ' },
      credit_charge_fee_amount: { title: 'クレジットチャージ手数料金額(摘要区分(79),入金区分(03,04))' },
      credit_charge_fee_number: { title: 'クレジットチャージ手数料件数(摘要区分(79),入金区分(03,04))' },
      credit_charge_fee_flag: { title: 'クレジットチャージ手数料フラグ' },
      atm_deposit_fee_amount2: { title: 'ATM出金手数料金額(摘要区分(80),入金区分(03,04))' },
      atm_deposit_fee_number2: { title: 'ATM出金手数料件数(摘要区分(80),入金区分(03,04))' },
      atm_deposit_fee_flag2: { title: 'ATM出金手数料フラグ' },
      refund_fee_amount: { title: '払い戻し金額(摘要区分(27),入金区分(03,04))' },
      refund_fee_number: { title: '払い戻し件数(摘要区分(27),入金区分(03,04))' },
      refund_fee_flag: { title: '払い戻しフラグ' },
      point_charge_a_amount: { title: 'ポイントチャージA金額(摘要区分(85))' },
      point_charge_a_number: { title: 'ポイントチャージA件数(摘要区分(85))' },
      point_charge_a_flag: { title: 'ポイントチャージAフラグ' },
      point_charge_b_amount: { title: 'ポイントチャージB金額(摘要区分(86))' },
      point_charge_b_number: { title: 'ポイントチャージB件数(摘要区分(86))' },
      point_charge_b_flag: { title: 'ポイントチャージBフラグ' },
      payroll_amount: { title: 'ペイロール金額(摘要区分(87))' },
      payroll_number: { title: 'ペイロール件数(摘要区分(87))' },
      payroll_flag: { title: 'ペイロールフラグ' },
    }
  },
  applicationUserData: {
    fileName: "ApplicationUserData",
    labels: {
      wallet_service_id: { title: 'ウォレットサービスID' },
      application_user_id: { title: 'アプリユーザID' },
      partner_member_id: { title: '提携先会員ID' },
      birthday: { title: '生年月日' },
      sex: { title: '性別' },
      rep_contract_settlement_method_id: { title: '代表契約決済手段ID' },
      agreement_id: { title: '同意した利用規約ID' },
      agreement_date: { title: '利用規約同意日時' },
      agreement_otasuke_id: { title: '同意済お助け利用規約ID' },
      agreement_otasuke_date: { title: 'お助け利用規約同意日時' },
      agreement_kyc_id: { title: '同意したKYC利用規約ID' },
      agreement_kyc_date: { title: 'KYC利用規約同意日時' },
      default_payment_method_id: { title: 'デフォルト決済手段ID' },
      status: { title: 'ステータス' },
      account_lock_status: { title: 'アカウントロック状態' },
      otasuke_status: { title: 'お助けステータス' },
      otasuke_settlement_count: { title: 'お助け精算回数' },
      mail_address: { title: 'メールアドレス' },
      receive_mail: { title: 'メール通知を受信する' },
      receive_notif: { title: 'PUSH通知を受信する' },
      login_id: { title: 'ログインID' },
      mobile: { title: '携帯電話番号' },
      friend_code: { title: 'フレンドコード' },
      nickname: { title: 'ニックネーム' },
      withdraw_date: { title: '退会日時' },
      withdraw_reason: { title: '退会理由' },
      withdraw_execution_code: { title: '退会時発行コード' },
      password_trial_count: { title: 'パスワード試行回数' },
      login_lock_date: { title: 'ログインロック日時' },
      last_password_change_date: { title: '最終パスワード変更日時' },
      device_model_name: { title: 'デバイス機種名' },
      device_os_type: { title: 'デバイスOS種別' },
      device_os_version: { title: 'デバイスOSバージョン' },
      popinfoID: { title: 'popinfoID' },
      management_user_id: { title: '作成管理ユーザID' },
      last_update_management_user_id: { title: '最終更新管理ユーザID' },
      created_at: { title: '作成日時' },
      updated_at: { title: '最終更新日時' },
      other: { title: '予備' },
    },
  },
  paymentMethodData: {
    fileName: "PaymentMethodData",
    labels: {
      wallet_service_id: { title: 'ウォレットサービスID' },
      wallet_service_name: { title: 'ウォレットサービス名' },
      application_user_id: { title: 'アプリユーザID' },
      payment_method_id: { title: '決済手段ID' },
      contract_number: { title: '契約番号' },
      payment_service: { title: '決済サービス' },
      created_at: { title: '作成日時' },
      updated_at: { title: '最終更新日時' },
      other: { title: '予備' },
    },
  },
  transactionData: {
    fileName: "TransactionData",
    labels: {
      contract_number: { title: '契約番号' },
      transaction_date: { title: '取引日' },
      format_category: { title: 'フォーマット区分' },
      sales_payment_category: { title: '売上・入金区分' },
      summary_category: { title: '摘要区分' },
      currency_code: { title: '通貨コード' },
      settlement_operation_amount: { title: '決済買上金額/入出金額' },
      settlement_atm_fee_amount: { title: '決済ATM手数料' },
      card_type: { title: 'カード種類ID' },
      companyId: { title: '企業ID' },
      filler: { title: 'FILLER' },
    },
  },
  transactionDataNinshou: {
    fileName: "TransactionDataNinshou",
    labels: {
      contract_number: { title: '契約番号' },
      transaction_date: { title: '取引日' },
      format_category: { title: 'フォーマット区分' },
      sales_payment_category: { title: '売上・入金区分' },
      summary_category: { title: '摘要区分' },
      currency_code: { title: '通貨コード' },
      settlement_operation_amount: { title: '決済買上金額/入出金額' },
      settlement_atm_fee_amount: { title: '決済ATM手数料' },
      card_type: { title: 'カード種類ID' },
      companyId: { title: '企業ID' },
      filler: { title: 'FILLER' },
      approved_sales_details_id: { title: '承認売上明細ID' },
      transaction_specific_information: { title: '取引特定情報' },
      original_transaction_specific_information: { title: '元取引特定情報' },
      initial_transaction_specific_information: { title: '当初取引特定情報' },
      card_number: { title: 'ｶｰﾄﾞ番号' },
      purchase_date: { title: '買上日' },
      transaction_details_date: { title: '取引日' },
      sales_details_category: { title: '売上区分' },
      summary_details_category: { title: '摘要区分' },
      business_category_code: { title: '業務区分ｺｰﾄﾞ' },
      approval_number: { title: '承認番号' },
      transaction_id: { title: 'ﾄﾗﾝｻﾞｸｼｮﾝID' },
      balance_adjustment_information_id: { title: '残高調整情報ID' },
      base_currency_code: { title: '基準通貨ｺｰﾄﾞ（数字）' },
      base_purchase_amount_code: { title: '基準買上金額符号' },
      base_purchase_amount: { title: '基準買上金額' },
      base_local_fee_code: { title: '基準現地手数料符号' },
      base_local_fee: { title: '基準現地手数料' },
      settlement_currency_code: { title: '決済通貨ｺｰﾄﾞ（数字）' },
      settlement_atm_fee_details_code: { title: '決済ATM手数料符号' },
      settlement_atm_fee_details: { title: '決済ATM手数料' },
      settlement_overseas_handling_fee_code: { title: '決済海外取扱手数料符号' },
      settlement_overseas_handling_fee: { title: '決済海外取扱手数料' },
      used_currency_code: { title: '利用通貨ｺｰﾄﾞ（数字）' },
      purchase_amount_code: { title: '利用買上金額符号' },
      purchase_amount: { title: '利用買上金額' },
      local_fee_code: { title: '利用現地手数料符号' },
      local_fee: { title: '利用現地手数料' },
      country_code: { title: '国ｺｰﾄﾞ' },
      brand_currency_rate: { title: 'ﾌﾞﾗﾝﾄﾞ通貨ﾚｰﾄ' },
      yen_conversion_rate: { title: '円貨換算ﾚｰﾄ' },
      yen_conversion_rate_application_date: { title: '円貨換算ﾚｰﾄ適用日' },
      purchased_amount_after_conversion: { title: '円換算後買上金額' },
      before_update_balance_code: { title: '更新前残高符号' },
      before_update_balance: { title: '更新前残高' },
      before_update_cumulative_amount_yen_usage_day: { title: '更新前円貨利用累積額（ １日)' },
      before_update_cumulative_amount_yen_usage_month: { title: '更新前円貨利用累積額（１ヶ月)' },
      merchant_category_code: { title: '加盟店業種ｺｰﾄﾞ' },
      merchant_contractor_code: { title: '加盟店契約業者ｺｰﾄﾞ' },
      merchant_slip_number: { title: '加盟店伝票番号' },
      merchant_id: { title: '加盟店ID' },
      merchant_terminal_id: { title: '加盟店端末ID' },
      merchant_name: { title: '加盟店名' },
      disable_cancellation_flag: { title: '障害取消ﾌﾗｸﾞ' },
      counter_number: { title: 'ｶｳﾝﾀ番号' },
      source_category: { title: '送信元区分' },
      after_update_balance: { title: '残高更新結果' },
      business_error_code: { title: '業務ｴﾗｰｺｰﾄﾞ' },
      pos_entry_mode: { title: 'POS Entry Mode' },
      approval_deletion_category: { title: '承認削除区分' },
      daikou_flag: { title: '代行有無ﾌﾗｸﾞ' },
      international_brand_risk_core_information: { title: '国際ﾌﾞﾗﾝﾄﾞﾘｽｸｽｺｱ情報' },
      screen_canceled_flag: { title: '画面取消済ﾌﾗｸﾞ' },
      payment_type: { title: '支払ﾀｲﾌﾟ' },
      timestamp: { title: 'ﾀｲﾑｽﾀﾝﾌﾟ' },
      token_number: { title: 'トークン番号' },
      filler_details: { title: 'FILLER' },
    },
  },
  transactionDataUriage: {
    fileName: "TransactionDataUriage",
    labels: {
      contract_number: { title: '契約番号' },
      transaction_date: { title: '取引日' },
      format_category: { title: 'フォーマット区分' },
      sales_payment_category: { title: '売上・入金区分' },
      summary_category: { title: '摘要区分' },
      currency_code: { title: '通貨コード' },
      settlement_operation_amount: { title: '決済買上金額/入出金額' },
      settlement_atm_fee_amount: { title: '決済ATM手数料' },
      card_type: { title: 'カード種類ID' },
      companyId: { title: '企業ID' },
      filler: { title: 'FILLER' },
      sales_details_id: { title: '売上明細ID' },
      transaction_specific_information: { title: '取引特定情報' },
      original_transaction_specific_information: { title: '元取引特定情報' },
      card_number: { title: 'ｶｰﾄﾞ番号' },
      international_brand_data_id: { title: '国際ﾌﾞﾗﾝﾄﾞﾃﾞｰﾀID' },
      original_international_brand_data_id: { title: 'ｵﾘｼﾞﾅﾙ国際ﾌﾞﾗﾝﾄﾞﾃﾞｰﾀID' },
      cpd: { title: 'CPD' },
      purchase_date: { title: '買上日' },
      transaction_details_date: { title: '取引日' },
      sales_details_category: { title: '売上区分' },
      summary_details_category: { title: '摘要区分' },
      approval_number: { title: '承認番号' },
      transaction_id: { title: 'ﾄﾗﾝｻﾞｸｼｮﾝID' },
      balance_adjustment_information_id: { title: '残高調整情報ID' },
      base_currency_code: { title: '基準通貨ｺｰﾄﾞ（数字）' },
      base_purchase_amount_code: { title: '基準買上金額符号' },
      base_purchase_amount: { title: '基準買上金額' },
      base_local_fee_code: { title: '基準現地手数料符号' },
      base_local_fee: { title: '基準現地手数料' },
      settlement_currency_code: { title: '決済通貨ｺｰﾄﾞ（数字）' },
      settlement_purchase_amount_code: { title: '決済買上金額符号' },
      settlement_purchase_amount: { title: '決済買上金額' },
      settlement_atm_fee_details_code: { title: '決済ATM手数料符号' },
      settlement_atm_fee_details: { title: '決済ATM手数料' },
      settlement_overseas_handling_fee_code: { title: '決済海外取扱手数料符号' },
      settlement_overseas_handling_fee: { title: '決済海外取扱手数料' },
      used_currency_code: { title: '利用通貨ｺｰﾄﾞ（数字）' },
      purchase_amount_code: { title: '利用買上金額符号' },
      purchase_amount: { title: '利用買上金額' },
      local_fee_code: { title: '利用現地手数料符号' },
      local_fee: { title: '利用現地手数料' },
      country_code: { title: '国ｺｰﾄﾞ' },
      settlement_currency_rate: { title: '決済通貨ﾚｰﾄ' },
      merchant_category_code: { title: '加盟店業種ｺｰﾄﾞ' },
      merchant_contractor_code: { title: '加盟店契約業者ｺｰﾄﾞ' },
      merchant_id: { title: '加盟店ID' },
      terminal_id: { title: '端末ID' },
      arn_ard: { title: 'ARN/ARD' },
      merchant_name: { title: '加盟店名' },
      pos_entry_mode: { title: 'POS Entry Mode' },
      charge_back_flag: { title: 'ﾁｬｰｼﾞﾊﾞｯｸ中ﾌﾗｸﾞ' },
      presentment: { title: 'Presentment' },
      screen_canceled_flag: { title: '画面取消済ﾌﾗｸﾞ' },
      timestamp: { title: 'ﾀｲﾑｽﾀﾝﾌﾟ' },
      release_date: { title: '保留解除日' },
      token_number: { title: 'トークン番号' },
      filler_details: { title: 'FILLER' },
    },
  },
  transactionDataNyuushutsukin: {
    fileName: "TransactionDataNyuushutsukin",
    labels: {
      contract_number: { title: '契約番号' },
      transaction_date: { title: '取引日' },
      format_category: { title: 'フォーマット区分' },
      sales_payment_category: { title: '売上・入金区分' },
      summary_category: { title: '摘要区分' },
      currency_code: { title: '通貨コード' },
      settlement_operation_amount: { title: '決済買上金額/入出金額' },
      settlement_atm_fee_amount: { title: '決済ATM手数料' },
      card_type: { title: 'カード種類ID' },
      companyId: { title: '企業ID' },
      filler: { title: 'FILLER' },
      deposit_details_id: { title: '入金明細ID' },
      transaction_specific_information: { title: '取引特定情報' },
      original_transaction_specific_information: { title: '元取引特定情報' },
      deposit_date: { title: '入金日' },
      transaction_details_date: { title: '取引日' },
      deposit_identification: { title: '入金識別' },
      deposit_category: { title: '入金区分' },
      summary_details_category: { title: '摘要区分' },
      deposit_transaction_category: { title: '入金取引区分' },
      deposit_currency_code: { title: '入金通貨ｺｰﾄﾞ（数字）' },
      deposit_amount_code: { title: '入金額符号' },
      deposit_amount: { title: '入金額' },
      balance_adjustment_information_id: { title: '残高調整情報ID' },
      before_update_balance_code: { title: '更新前残高符号' },
      before_update_balance: { title: '更新前残高' },
      after_update_balance: { title: '残高更新結果' },
      business_error_code: { title: '業務ｴﾗｰｺｰﾄﾞ' },
      screen_canceled_flag: { title: '画面取消済ﾌﾗｸﾞ' },
      timestamp: { title: 'ﾀｲﾑｽﾀﾝﾌﾟ' },
      summary: { title: '摘要文言' },
      filler_details: { title: 'FILLER' },
    },
  },
  paymentTransactionsData: {
    fileName: "PaymentTransactionsData",
    labels: {
      transaction_id: { title: '取引ID' },
      transaction_date: { title: '取引年月日' },
      transaction_code: { title: '取引コード' },
      transaction_type: { title: '取引区分' },
      settlement_code: { title: '決済区分コード' },
      withdraw_payment_service_code: { title: '出金決済サービスコード' },
      withdraw_user_id: { title: '出金ユーザID' },
      deposit_payment_service_code: { title: '入金決済サービスコード' },
      deposit_user_id: { title: '入金ユーザID' },
      value_issuer_id: { title: 'バリューイシュアID' },
      wallet_service_id: { title: 'ウォレットサービスID' },
      company_id: { title: '企業ID' },
      store_id: { title: '店舗ID' },
      terminal_id: { title: '端末ID' },
      designated_amount: { title: '指定金額' },
      transaction_amount: { title: '取引金額' },
      contract_number: { title: '契約番号' },
      processing_number: { title: '処理通番' },
      business_number: { title: '業務通番' },
      summary: { title: '摘要区分' },
      failure_cancellation_flag: { title: '障害取消フラグ' },
      currency: { title: '取引通貨' },
      remittance_destination_contract_number: { title: '送金振替先契約番号' },
      fee: { title: '手数料' },
      other: { title: '予備' },
    },
  },
  merchantData: {
    fileName: "MerchantData",
    labels: {
      company_identification_code: { title: '企業識別コード' },
      company_id: { title: '企業ID' },
      company_name: { title: '企業名' },
      company_postcode: { title: '企業郵便番号' },
      company_address1: { title: '企業住所１' },
      company_address2: { title: '企業住所２' },
      company_phone: { title: '企業電話番号' },
      store_identification_code: { title: '店舗識別コード' },
      store_id: { title: '店舗ID' },
      store_name: { title: '店舗名' },
      store_postcode: { title: '店舗郵便番号' },
      store_address1: { title: '店舗住所１' },
      store_address2: { title: '店舗住所２' },
      store_phone: { title: '店舗電話番号' },
      service_start_date: { title: 'サービス開始日付' },
      cancellation_date: { title: '解約日付' },
      terminals_number: { title: '設置端末台数' },
      other: { title: '予備' },
    },
  },
  merchantTerminalData: {
    fileName: "MerchantTerminalData",
    labels: {
      company_identification_code: { title: '企業識別コード' },
      company_id: { title: '企業ID' },
      company_name: { title: '企業名' },
      company_postcode: { title: '企業郵便番号' },
      company_address1: { title: '企業住所１' },
      company_address2: { title: '企業住所２' },
      company_phone: { title: '企業電話番号' },
      store_identification_code: { title: '店舗識別コード' },
      store_id: { title: '店舗ID' },
      store_name: { title: '店舗名' },
      store_postcode: { title: '店舗郵便番号' },
      store_address1: { title: '店舗住所１' },
      store_address2: { title: '店舗住所２' },
      store_phone: { title: '店舗電話番号' },
      service_start_date: { title: 'サービス開始日付' },
      cancellation_date: { title: '解約日付' },
      terminals_number: { title: '設置端末台数' },
      terminal_id: { title: '端末ID' },
      terminal_type: { title: '端末利用種別' },
      terminal_usage_start: { title: '端末利用開始日' },
      terminal_usage_end: { title: '端末利用終了日' },
      other: { title: '予備' },
    },
  },
  otasukeRepaymentData: {
    fileName: "OtasukeRepaymentData",
    labels: {
      settlement_id: { title: '精算ID' },
      advance_id: { title: '立替ID' },
      transaction_id: { title: '取引ID' },
      settlement_method: { title: '精算手段' },
      settlement_execution_result_code: { title: '精算実行結果コード' },
      settlement_date: { title: '精算日' },
      settlement_amount: { title: '精算金額' },
      settlement_capital: { title: '精算元金' },
      settlement_fee: { title: '精算手数料' },
      other: { title: '予備' },
    },
  },
  otasukeForecastData: {
    fileName: "OtasukeForecastData",
    labels: {
      advance_id: { title: '立替ID' },
      transaction_id: { title: '取引ID' },
      application_user_id: { title: 'アプリユーザID' },
      advance_date: { title: '立替日' },
      advance_amount: { title: '立替金額' },
      advance_capital: { title: '立替元金' },
      advance_fee: { title: '立替手数料' },
      settlement_status: { title: '精算ステータス' },
      settlement_scheduled_date: { title: '精算予定日' },
      settlement_start_date: { title: '精算開始日' },
      settlement_method: { title: '精算完了した時の精算手段' },
      settlement_end_date: { title: '精算完了日' },
      other: { title: '予備' },
    },
  },
  userSummary: {
    fileName: "UserSummary",
    labels: {
      PID: { title: 'PID' },
      パートナー名: { title: 'パートナー名' },
      カード種類: { title: 'カード種類' },
      登録数: { title: '登録数' },
      累計登録数: { title: '累計登録数' },
    },
  },
  userSummaryList: {
    fileName: "UserSummaryList",
    labels: {
      PID: { title: 'PID' },
      パートナー名: { title: 'パートナー名' },
      カード種類ID: { title: 'カード種類ID' },
      カード種類: { title: 'カード種類' },
      契約日: { title: '契約日' },
    },
  },
  transactionsSummary: {
    fileName: "TransactionsSummary",
    labels: {
      propertyName: { title: '項目' },
      件数: { title: '件数' },
      利用会員数: { title: '利用会員数' },
      金額: { title: '金額' },
    },
  }
}
const _industries = [
  { display: "仕事紹介", value: "job" },
  { display: "保険", value: "insurance" },
  { display: "海外送金", value: "remittance" },
  { display: "オンライン教育", value: "education" },
  { display: "オンラインショッピング", value: "shopping" },
  { display: "携帯電話SIM", value: "mobile" },
  { display: "家賃保証（不動産）", value: "estate" },
  { display: "エンタメ", value: "enter" },
  { display: "旅行", value: "travel" },
  { display: "ゲーム", value: "game" },
  { display: "法人向け", value: "corporate" },
  { display: "フリーランス向け", value: "freelance" },
  { display: "寄付、ボランティア", value: "donation" },
  { display: "キャンペーン情報", value: "campaign" }
];
const _notificationOptions = [
  { display: "有効", value: "available" },
  { display: "停止", value: "stop" },
];

const _statusOptions = [
  { display: "有効", value: "available" },
  { display: "停止", value: "stop" },
  { display: "退会", value: "withdrawal" },
];

const _withdrawReasonOptions = [
  { display: "自主退会", value: "self" },
  { display: "管理操作", value: "operation" },
  { display: "電話番号重複", value: "conflict" },
];

const _lock_statusOptions = [
  { display: "未ロック", value: "00000000000000000000" },
  { display: "ロック", value: "00000000000000000001" },
];

const _otasuke_statusOptions = [
  { display: "利用可能", value: "available" },
  { display: "利用不可", value: "unavailable" },
];

const _transactionOptions = [
  { display: "QRコード決済", value: "qr" },
  { display: "おたすけチャージ", value: "otasuke_charge" },
  { display: "クレカチャージ", value: "credit_charge" },
  { display: "個人間送金", value: "remittance" },
  { display: "振替", value: "self_transfer" },
  { display: "おたすけチャージ早期返済", value: "otasuke_sokubarai" },
  { display: "おたすけチャージ指定日返済", value: "otasuke_atobarai" },
];

const _settlementOptions = [
  { display: "精算済み", value: "paid" },
  { display: "未精算", value: "unpaid" }
];

const _settlementMethodOptions = [
  { display: "償却", value: "amortization" },
  { display: "自動（指定日）", value: "auto_date" },
  { display: "手動", value: "manual" },
  { display: "残高回収", value: "withdrawal" }
];
const _sexOptions = [
  { display: "女性", value: "female" },
  { display: "男性", value: "male" },
  { display: "不明", value: "unknown" },

];

const _settlementCodeOptions = [
  { display: "口振口座※未使用", value: "direct_bank" },
  { display: "クレジットカード※未使用", value: "credit_card" },
  { display: "プリペイド", value: "prepaid" },
];

const _transactionCodeOptions = [
  { display: "QRコード決済・おたすけチャージ", value: "0" },
  { display: "決済取消・おたすけ支払い・クレカチャージ", value: "1" },
  { display: "個人間送金、振替", value: "2" },
];

const _failureCancellationFlagOptions = [
  { display: "通常", value: "0" },
  { display: "取消", value: "1" },
]

const _formatCategories = {
  "01": "承認売上",
  "02": "売上",
  "03": "入出金",
};
const _formatMapping = {
  "承認売上": "01",
  "売上": "02",
  "入出金": "03",
};

const _summaryCategories = {
  "01": "国内ショッピング",
  "02": "海外ショッピング",
  "03": "海外現金引出",
  "04": "為替差額",
  "05": "海外調整額",
  "06": "年会費",
  "13": "入金(調整)",
  "14": "入金(振込)",
  "15": "出金(会員依頼)",
  "16": "出金(調整)",
  "17": "返金(解約)",
  "21": "再発行手数料",
  "22": "利用明細発行手数料",
  "23": "有効期限更新時再発行手数料",
  "24": "暗証番号通知手数料",
  "26": "入金手数料",
  "27": "出金手数料",
  "28": "入金(会員依頼)",
  "29": "入金(償却)",
  "30": "出金(解約)",
  "31": "出金(振込取消)",
  "47": "入金(クレジットチャージ)",
  "52": "初回発行手数料",
  "60": "入金(おたすけチャージ)",
  "62": "出金(おたすけチャージ返済)",
  "63": "出金(ＱＲ決済)",
  "64": "入金(ＱＲ決済取消)",
  "65": "入金(ＡＴＭ入金)",
  "66": "出金(ＡＴＭ出金)",
  "67": "入金(振替)",
  "68": "出金(振替)",
  "69": "入金(送金)",
  "70": "出金(送金)",
  "75": "入金（一括）",
  "76": "出金（一括）",
  "77": "おたすけチャージ手数料(CF表示専用)",
  "78": "ＡＴＭ入金手数料(CF表示専用)",
  "79": "クレジットチャージ手数料(CF表示専用)",
  "80": "ＡＴＭ出金手数料(CF表示専用)",
};

const _salesCategories = {
  "01": "承認売上",
  "02": "承認取消",
  "03": "売上",
  "04": "売上取消",
  "05": "返品",
  "06": "返品取消",
  "07": "承認返品",
  "08": "承認売上(削除)",
  "09": "承認取消(削除)",
  "10": "承認返品(削除)",
  "11": "承認売上(障取)",
  "12": "承認取消(障取)",
  "13": "承認返品(障取)",
};

const _paymentCategories = {
  "01": "入金",
  "02": "入金取消",
  "03": "出金",
  "04": "出金取消",
  "05": "返金",
};
const _valid_member_options = {
  "0": "退会",
  "1": "有効"
};

const _businessCategories = {
  "0": "売上",
  "1": "無効カード照会",
  "2": "オーソリ予約",
  "3": "取消",
  "4": "返品",
  "5": "オーソリ予約の取消",
  "6": "承認番号付売上",
  "V": "ボイスオーソリ",
};

const _sourcesCategories = {
  "1": "FES",
  "2": "BES",
  "3": "WEB",
};
const _approvalDeletionCategories = {
  "0": "未確定",
  "1": "突合済",
  "2": "期間経過削除",
  "3": "取消済",
  "4": "取消元",
  "5": "障害取消",
  "6": "一部取消済",
  "7": "一部取消元",
  "8": "一部取消元(複)",
};

const _screenCancelationCategories = {
  "0": "取消なし",
  "1": "取消あり",
};

const _paymentTransactionsCategories = {
  "R": "リカーリング",
  "I": "割賦",
  "": "設定なし",
};

const _depositIdentificationCategories = {
  "0": "初期入金",
  "1": "再入金",
};

const _depositCategories = {
  "01": "入金",
  "02": "入金取消",
  "03": "出金",
  "04": "出金取消",
  "05": "返金",
};
const _depositTransactionCategory = {
  "01": "事前オートチャージ",
  "02": "事後オートチャージ",
  "03": "手動チャージ",
  "04": "イシュア調整入金",
  "05": "振込入金",
  "06": "会員依頼出金",
  "07": "解約返金",
  "08": "イシュア調整出金",
  "09": "会員依頼入金",
  "10": "償却入金",
  "11": "解約出金",
  "12": "振込入金取消"
};

export default {
  data() {
    return {
      redirects: _redirects,
      jobValues: _jobValues,
      langLevels: _langLevels,
      prefs: _prefs,
      outputInfo: _outputInfo,
      tsvFormat: _tsvFormat,
      fields: _fields,
      identification_codes: _identification_codes,
      account_type_codes: _account_type_codes,
      authentication_a_codes: _authentication_a_codes,
      authentication_b_codes: _authentication_b_codes,
      transaction_purpose_codes: _transaction_purpose_code,
      occupation_codes: _occupation_code,
      card_type_codes: _card_types_code,
      csvFields: _csvFields,
      csvFieldsChoysan: _csvFieldsChoysan,
      verificationFields: _verificationFields,
      industries: _industries,
      userstatus: _userstatus,
      notificationOptions: _notificationOptions,
      transactionOptions: _transactionOptions,
      settlementOptions: _settlementOptions,
      settlementMethodOptions: _settlementMethodOptions,
      sexOptions: _sexOptions,
      formatCategories: _formatCategories,
      summaryCategories: _summaryCategories,
      salesCategories: _salesCategories,
      paymentCategories: _paymentCategories,
      statusOptions: _statusOptions,
      lockStatusOptions: _lock_statusOptions,
      otasuke_statusOptions: _otasuke_statusOptions,
      transactionCodeOptions: _transactionCodeOptions,
      settlementCodeOptions: _settlementCodeOptions,
      failureCancellationFlagOptions: _failureCancellationFlagOptions,
      valid_member_options: _valid_member_options,
      businessCategories: _businessCategories,
      sourcesCategories: _sourcesCategories,
      approvalDeletionCategories: _approvalDeletionCategories,
      screenCancelationCategories: _screenCancelationCategories,
      paymentTransactionsCategories: _paymentTransactionsCategories,
      depositIdentificationCategories: _depositIdentificationCategories,
      depositCategories: _depositCategories,
      depositTransactionCategory: _depositTransactionCategory,
      withdrawReasonOptions: _withdrawReasonOptions,
      transactionsFieldsMapping: _transactionsFieldsMapping,
      formatMapping: _formatMapping,
    }
  }
}

